import React from 'react';

const MICRO = 'block text-[10px] font-semibold uppercase tracking-[0.1em] text-muted mb-1';
const CONTROL =
  'text-[12.5px] text-ink bg-surface border border-line rounded-tc-sm px-3 py-2 min-h-[38px] ' +
  'focus:outline-none focus:ring-2 focus:ring-accent disabled:opacity-50 disabled:cursor-not-allowed';

// Filter bar of the Projects page. Pure presentation: all state lives in ProjectsPage.
// Year and month are applied by the server (the page re-fetches); the rest filters client-side.
export default function ProjectsFilterBar({
  values, onChange, years, months, clients, departments,
  hasActiveFilters, onClear, resultCount,
}) {
  const { search, client, dept, year, month } = values;
  return (
    <div className="flex flex-wrap items-end gap-3 mb-4">
      <label className="block flex-1 min-w-[14rem]">
        <span className={MICRO}>Search</span>
        <input
          type="text"
          aria-label="Search"
          placeholder="Search project, client, requested by…"
          value={search}
          onChange={(e) => onChange('search', e.target.value)}
          className={`${CONTROL} w-full`}
        />
      </label>

      <label className="block">
        <span className={MICRO}>Client</span>
        <select aria-label="Client" value={client} onChange={(e) => onChange('client', e.target.value)} className={CONTROL}>
          <option value="">All clients</option>
          {clients.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </label>

      <label className="block">
        <span className={MICRO}>Department</span>
        <select aria-label="Department" value={dept} onChange={(e) => onChange('dept', e.target.value)} className={CONTROL}>
          <option value="">All departments</option>
          {departments.map((d) => <option key={d} value={d}>{d}</option>)}
        </select>
      </label>

      <label className="block">
        <span className={MICRO}>Year</span>
        <select aria-label="Year" value={year} onChange={(e) => onChange('year', e.target.value)} className={CONTROL}>
          <option value="">All years</option>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </label>

      {/* Always rendered. The month survives a change of year; it only applies within a year. */}
      <label className="block">
        <span className={MICRO}>Month</span>
        <select
          aria-label="Month"
          value={month}
          onChange={(e) => onChange('month', e.target.value)}
          disabled={!year}
          title={year ? undefined : 'Pick a year to filter by month'}
          className={CONTROL}
        >
          <option value="">All months</option>
          {months.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
        </select>
      </label>

      {hasActiveFilters && (
        <button
          type="button"
          onClick={onClear}
          className="bg-surface text-muted text-[12.5px] border border-line rounded-tc-sm px-3.5 min-h-[38px]"
        >
          Reset filters · {resultCount} results
        </button>
      )}
    </div>
  );
}
